export const LOCAL_STORAGE_KEYS = {
  session: 'session_data'
} as const

export const useLocalStorageService = () => {
  const isAvailable = () => typeof localStorage !== 'undefined'

  const getItem = (key: string) => {
    if (isAvailable()) {
      return localStorage.getItem(key)
    } else {
      console.error('Browser does not support localStorage')
    }
  }

  const setItem = (key: string, value: any) => {
    if (isAvailable()) {
      localStorage.setItem(key, value)
    } else {
      console.error('Browser does not support localStorage')
    }
  }

  const removeItem = (key: string) => {
    if (isAvailable()) {
      localStorage.removeItem(key)
    } else {
      console.error('Browser does not support localStorage')
    }
  }

  return {
    getItem,
    setItem,
    removeItem
  }
}
